fx.ns("desktop.common.toolbar", class ToolBarBorderSelector  extends shared.stage.ToolBarButton{
    
    constructor(command, component, container)
    {
        super(command, component, container);

        this._scrollerDisplayed  = false;

        if (component.data.side && typeof component.data.side == "string" && (component.data.side.startsWith("rgb") || component.data.side.startsWith("#")))
            this._color = component.data.side;
        else 
            this._color = "rgb(0,0,0)";

        this._thickness = component.data.borderid || 0;
    }

  
    create()
    {
        this.scroller = new fx.components.Box("BorderSelectorContainer");
        this.scroller.visibleAtStart = false;

        this.textlabel = new fx.components.Text({className : "textLabel", text : fx.text("Epaisseur")});
        this.range = new fx.components.InputRange({value : this._thickness, min : 0, max : 10});
        this.rangeValue = new fx.components.Text({className : "rangeLabel", text : this._thickness});

        this.colorPicker = new fx.components.ColorPickerButton({lastColors : this.container.model.customcolors ? this.container.model.customcolors.toArray() : null, lastColor : this._color, showOpacity : true, noEffect : true});
        this.lastColors = new shared.panels.LastColors( this.container.model.customcolors );

        this.scroller.addChild( this.range, {width : 150, height :15, top : 12.5, left : 5});
        this.scroller.addChild( this.textlabel, {width : "auto", height :20, top : 34, left : 55});
        this.scroller.addChild( this.rangeValue, {width : 30, height :40, left : 160, top : 15});
        this.scroller.addChild( this.colorPicker, {width:35, height:55, left : 200, top : 0});
		this.scroller.addChild( this.lastColors, {width:"auto", height:55, left : 235, top :0});
        
        this.container.addChild( this.scroller, {width : 420, height :50, bottom : -50,/*top:this.container.realHeight,*/ left : "center"} );
    }

    onReady()
    {
        super.onReady();
        
        this.on("click",this._click, window);
        this.on("changed", this._updateRangeLabel, this.range);
        this.on("color", this.onColor, this.colorPicker);
        this.on("color", this.onLastColor, this.lastColors);
        
    }


    onLastColor(e)
    {
        this.colorPicker.currentColor = e.detail;
    }

    onColor(e)
	{
        this._color = e.detail;

        if (this.range.value == 0)
        {
            this.range.value = 1;
            this.rangeValue.text = this.range.value;  
        }
            
        

        this._action();
	}

    _updateRangeLabel()
    {
        this.rangeValue.text = this.range.value;  

        this._action();
    }

    _action()
    {
        this.action( {thickness : this.range.value, color :  this._color});
    }

    click()
    {
        // we disabled default action on click
    }

    _click(event)
    {
        if (!this.enabled)
            return;

        let toolBar = fx.dom.parent(event.target, ".ToolBar");
        if (!toolBar)
            return;

        let target1 = fx.dom.parent(event.target, ".ToolBarBorderSelector");
        let target2 = fx.dom.parent(event.target, ".BorderSelectorContainer");
        

        if ( (target1 && target1.id == this.id) )
            this.updateScoller(!this.scroller.visible);
        else
        if ( ( !target2 || target2.id != this.scroller.id) && this._scrollerDisplayed )
            this.updateScoller(false);
            
    }

    updateScoller(show)
    {
        if (show)
        {
            this.scroller.show();
            this.addClass("pushed");
        }
        else
        {
            this.scroller.hide();
            this.removeClass("pushed");
        }

        this._scrollerDisplayed = show;
    }


    destroy()
    {
        super.destroy();


        if (this.container && this.scroller)
            this.container.removeChild( this.scroller , true);

    }


    hide()
    {
        super.hide();
        this.css({display:"none"});
    }

    show()
    {
        super.show();
        this.css({display:"inline-block"});
    }

  
});
